import React, { ChangeEvent, useEffect, useRef } from "react";
import "./SelectMode.css";
import { useDispatch, useSelector } from 'react-redux';
import { updateMultiSettings } from "../../../../store/features/otherSettingsSlice";
import { warpGlobalSettingsFromTemplate } from "../../../../utils/templateUIConfigConverter";
import { updateGlobalSettings } from "../../../../store/features/globalSettingsSlice";
import { RootStore } from "../../../../store";
import defaultTpl from "../../../../assets/templates/ReadBarcodes_Default.json";
import speedFirst from "../../../../assets/templates/ReadBarcodes_SpeedFirst.json";
import readRateFirst from "../../../../assets/templates/ReadBarcodes_ReadRateFirst.json";
import { updateState } from "../../../../store/features/generalStatesSlice";

interface SelectModeProps {
  showHideAdvancedSettings: () => void
}

export default function SelectMode({ showHideAdvancedSettings }: SelectModeProps) {
  const globalSettings = useSelector((store: RootStore) => store.globalSettings);
  const generalStates = useSelector((store: RootStore) => store.generalStates);

  const globalSettingsRef = useRef(globalSettings);

  const dispatch = useDispatch();

  useEffect(()=>{
    globalSettingsRef.current = globalSettings;
  }, [globalSettings]);

  useEffect(() => {
    if (generalStates.scanningMode === 0) {
      const settings = warpGlobalSettingsFromTemplate(speedFirst, globalSettingsRef.current );
      dispatch(updateMultiSettings({ textCount: settings.ExpectedBarcodesCount.value, colour: "normal" }));
      dispatch(updateGlobalSettings({ settings }));
    } else if (generalStates.scanningMode === 1) {
      const settings = warpGlobalSettingsFromTemplate(defaultTpl, globalSettingsRef.current );
      dispatch(updateMultiSettings({ textCount: settings.ExpectedBarcodesCount.value, colour: "both" }));
      dispatch(updateGlobalSettings({ settings }));
    } else if (generalStates.scanningMode === 2) {
      const settings = warpGlobalSettingsFromTemplate(readRateFirst, globalSettingsRef.current );
      dispatch(updateMultiSettings({ textCount: settings.ExpectedBarcodesCount.value, colour: "both" }));
      dispatch(updateGlobalSettings({ settings }));
    }
  }, [dispatch, generalStates.scanningMode])

  const changeMode = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch(updateState({ stateName: "scanningMode", value: parseInt(e.target.value) }));
  }

  return (
    <div className="dbr-select-mode">
      <div className="dbr-select-mode-title">Scanning Mode : </div>
      <div className="dbr-slider-container">
        <span className="dbr-best-speed-ipad">Speed First</span>
        <input type="range" min="0" max="2" value={generalStates.scanningMode} className="dbr-slider" autoComplete="off" onChange={changeMode} />
        <span className="dbr-best-coverage-ipad">ReadRate First</span>
        <div className="dbr-slider-node">
          <span className="dbr-best-speed">Speed First</span>
          <span className="dbr-best-coverage">ReadRate First</span>
        </div>
      </div>
      <span className="dbr-as-span" onClick={showHideAdvancedSettings}>
        <span className="dbr-as-title">Advanced Settings</span>
        <svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9550" width="25" height="25"><path d="M880.48 451.488l-14.72-64 54.96-94.976-117.6-146.464-105.28 32L637.92 149.6 597.472 48H409.248l-40.464 101.6-59.904 28.544-105.28-32.064-117.616 146.448 54.96 94.976-14.72 64-90.976 61.872 42.016 182.864 108.944 16.512 41.312 51.456-8.016 109.216 169.696 80.976L470.064 880h66.592l80.864 74.4L787.2 873.328l-8-109.168 41.296-51.424 108.96-16.496 42-182.864-90.992-61.888z m-16.816 173.808l-86 13.056-80.576 100.32 6.336 86.16-71.664 34.08L567.808 800h-128.896l-63.968 58.912-71.664-34.176 6.336-86.112-80.576-100.304-86-13.04-17.568-76.528 71.696-48.768 28.8-125.28-43.296-74.832 49.424-61.552 83.248 25.328 116.224-55.408L463.52 128h79.664l31.952 80.24 116.224 55.488 83.248-25.36 49.424 61.536-43.296 74.816 28.8 125.28 71.712 48.752-17.6 76.544zM504.88 336c-92.64 0-167.968 75.36-167.968 168s75.36 168 168 168 168-75.36 168-168S597.536 336 504.88 336z m0.032 256a88.112 88.112 0 0 1-88-88c0-23.504 9.152-45.6 25.76-62.224A87.392 87.392 0 0 1 504.928 416c48.512 0 88 39.488 88 88s-39.488 88-88 88z" fill="#565D64" p-id="9551"></path></svg>
      </span>
    </div>
  )
}